import axios from "axios";
import React, { Component } from "react";
import {
    downloadAPIResponseJSON,
    changeRequestConfigToMockURL
} from "../utils/mockAPIWorker";

// Author : Sriram
/** Axios Interceptor class for downloading the mockresponses from server and render them in case of mock mode. **/
class MockInterceptor extends Component {
    // static  MOCK_ACTION = "off";   //Running with LIVE API
    // static MOCK_ACTION = "mock"; // Running with MOCK
    // static  MOCK_ACTION = "download";  // RUNNING with LIVE API and download the JSON responses to refresh seeddata store
    static MOCK_ACTION = "off"; // RUNNING with LIVE APImock
    static MOCK_API_SERVER_URL = "http://127.0.0.1:8125";
    static configResponseMockData = flag => {
        if (flag) {
            // Add a response interceptor
            axios.interceptors.response.use(
                function(response) {
                    if (MockInterceptor.MOCK_ACTION === "download") {
                        downloadAPIResponseJSON(response);
                    }
                    return response;
                },
                function(error) {
                    return Promise.reject(error);
                }
            );
            // Add a request interceptor
            axios.interceptors.request.use(
                function(config) {
                    if (MockInterceptor.MOCK_ACTION === "mock") {
                        changeRequestConfigToMockURL(
                            config,
                            MockInterceptor.MOCK_API_SERVER_URL
                        );
                    }

                    return config;
                },
                function(error) {
                    return Promise.reject(error);
                }
            );
        }
    };
}

export default MockInterceptor;



// WEBPACK FOOTER //
// ./src/interceptors/MockInterceptor.js